import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import Game from "./Game";

// Rounds
@inject('GameStore')
@observer
export default class GameStep4 extends Component {

    static defaultProps = {
        onChangeAnswer: () => {}
    };

    constructor(props) {
        super(props);
    }

    componentDidUpdate() {
        const btns = document.querySelectorAll(".btn-answer");
        for (let bt of btns) {
            bt.className = "btn-answer";
        }

        const btnNavNext = document.querySelector(".btn-nav-next");
        btnNavNext.className = "btn-nav-next disabled";
    }

    addPointsToScore(player, index, e) {
        this.props.onChangeAnswer({player, index});

        const btns = document.querySelectorAll(".btn-answer");
        for (let bt of btns) {
            bt.className = "btn-answer";
            if (bt.name === "btn" + index) {
                bt.className =  "btn-answer selected";

                const btnNavNext = document.querySelector(".btn-nav-next");
                btnNavNext.className = "btn-nav-next";
            }
        }
    }

    render() {

        const {
            GameStore
        } = this.props;

        const player = GameStore.getRandomPlayer();
        const question = GameStore.getRandomQuestionByLevel(player.levels);

        const answersEl = GameStore.answers.map(
            (answer, index) => <button
                name={"btn" + index}
                className="btn-answer"
                key={index}
                onClick={this.addPointsToScore.bind(this, player, index)}>{answer.label}</button>
        );

        return (
            <div className="step-4">
                <ScoreBar players={GameStore.players}/>
                <h1>Round {Math.ceil(GameStore.round / GameStore.numberPlayers)}</h1>
                <div className={"team-name " + player.team.color}>{player.name}</div>
                <div>
                    <div className="question">
                        {question.statement.image &&
                            <div className="question-image"
                                style={{backgroundImage: `url(images/${question.statement.image}.jpg)`}}/>
                        }
                        <div className="question-statement">
                            <p><strong>{question.level}</strong> <br/>{question.statement.statement}</p>
                            <div className="answers">
                                {answersEl}
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        )
    }
}

const ScoreBar = ({players = []}) => {

    const scores = players.map(
        (player, index) => (
            <Score key={index} player={player} />
        )
    );

    return (
        <div className="ScoreBar">
            {scores}
        </div>
    )
};

const Score = ({player}) => {
    return (
        <div className="Score">
            <div className={"team-name " + player.team.color}>{player.name}</div>
            <div>{player.score} Points</div>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/containers/Game/GameStep4.js